import React, { useEffect } from 'react'
import { useModuleSettings } from '../../context/adminSettingsContext';
import { Link, useLocation } from 'react-router-dom';
import { hasPermissionForModule } from '../../common/utils';

const Sidebar = () => {
    const { resetSettings } = useModuleSettings();
    const location = useLocation();

    useEffect(() => {
        if (window.feather) {
            window.feather.replace();
        }
    }, [location.pathname]);

    const handleNavigation = () => {
        resetSettings();
    };

    const menuItems = [
        {
            items: [
                { route: "/dashboard", icon: "home", text: "Dashboard", name: "dashboard" },

                { route: "/parents", icon: "users", text: "Parents", name: "parents" },
                { route: "/tutors", icon: "user-check", text: "Tutors", name: "tutors" },

                { route: "/bookings", icon: "calendar", text: "Booking", name: "bookings" },
                // { route: "/coupons", icon: "tag", text: "Coupon", name: "coupons" },
                { route: "/subscriptions", icon: "credit-card", text: "Subscription", name: "subscriptions" },
                { route: "/badges", icon: "award", text: "Badge", name: "badges" },

                { route: "/reviews", icon: "star", text: "Review", name: "review" },
                { route: "/earnings", icon: "dollar-sign", text: "Earning", name: "earnings" },
                { route: "/notification", icon: "bell", text: "Notification", name: "notification" },

                { route: "/reported-bookings", icon: "alert-circle", text: "Reported Bookings", name: "reported-bookings" },
                { route: "/subadmins", icon: "user-check", text: "Sub Admin", name: "subadmins" },

                {
                    route: "#sidebarCrm",
                    icon: "users",
                    text: "CMS",
                    name: "cms",
                    subItems: [
                      { route: "/about", text: "About Us" },
                      { route: "/privacy", text: "Privacy Policy" },
                      { route: "/terms", text: "Term & Condition" },
                      { route: "/faq", text: "FAQ" },
                      { route: "/contact", text: "Contact Us" },
                    ],
                  },
            ],
        },
    ];

    return (
        <>
            <div className="left-side-menu" style={{ overflowY: "auto" }}>
                <div className="h-100">
                    <div className="user-box text-center">
                        {/* User avatar and dropdown */}
                    </div>
                    <div id="sidebar-menu">
                        <ul id="side-menu">
                            {menuItems.map((section, sectionIndex) => (
                                <React.Fragment key={sectionIndex}>
                                    {section.items.map((item, itemIndex) => {
                                        const hasPermission =
                                            item.name === "dashboard" || hasPermissionForModule(item.name);

                                        if (!hasPermission) return null;

                                        const isActive = location.pathname === item.route;
                                        const isSubOpen = item?.subItems && item?.subItems?.some((val) => location.pathname === val.route);

                                        return (
                                            <li key={itemIndex} className={isActive || isSubOpen ? "menuitem-active" : ""}>
                                                <Link
                                                    to={item.route}
                                                    data-bs-toggle={item.subItems ? "collapse" : undefined}
                                                    onClick={() => {
                                                        handleNavigation();
                                                        if (!item.subItems) document.body.classList.remove('sidebar-enable');
                                                        // Re-initialize icons after navigation
                                                        setTimeout(() => {
                                                            if (window.feather) {
                                                                window.feather.replace();
                                                            }
                                                        }, 0);
                                                    }}
                                                >
                                                    <i data-feather={item.icon} />
                                                    {item.badge && (
                                                        <span className={`badge ${item.badge.class}`}>{item.badge.text}</span>
                                                    )}
                                                    <span> {item.text} </span>
                                                    {item.subItems && !item.badge && <span className="menu-arrow" />}
                                                </Link>
                                                {item.subItems && (
                                                    <div className="collapse" id={item.route.substring(1)}>
                                                        <ul className="nav-second-level">
                                                            {item.subItems.map((subItem, subItemIndex) => {
                                                                const isActive = location.pathname === subItem.route;
                                                                return (
                                                                    <li key={subItemIndex} className={isActive ? "menuitem-active" : ""}>
                                                                        <Link to={subItem.route} onClick={() => document.body.classList.remove('sidebar-enable')}>{subItem.text}</Link>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                )}
                                            </li>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sidebar;